module.exports = __webpack_public_path__ + "202408221624/img/6.5003c092.png";